import React from "react";

import { useSelector, useDispatch } from "react-redux";
import AvailabilityButton from "../AvailabilityButton";
import {
  setHotelOfferInfos,
  setOfferFlexbooked,
  setOfferId,
} from "amadeusredux/lib/hotelSlice";
import { views } from "../utils";
import OfferFlight from "./OfferFlight";
import { currencySymbol } from "../utils.js";

const df = new Intl.DateTimeFormat("de-DE", {
  weekday: "short",
  day: "2-digit",
  month: "2-digit",
  year: "2-digit",
});

const nf = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 2,
  maxiimumFractionDigits: 2,
});

export default function AlternativeOfferFlights(props) {
  const {
    comparableOffers,
    offer,
    display,
    stations,
    offsetTop,
    addOffer,
    hotelOfferInfos,
    hotel,
    flexSelected,
    mainOffer,
    flightOffer,
    selectedDeparture,
    selectedArrival,
    selectedOutboundAirport,
    alternativeFlightPage,
    setAlternativeFlightPage,
  } = props;
  const dispatch = useDispatch();
  let offerCountBeforefilter = comparableOffers.length;
  let offerDisplayed = false;
  let lastOutbound = {};
  let ct = 0;
  const airports = stations?.Station;

  return (
    <>
      {[...comparableOffers]

        .filter((e) =>
          selectedOutboundAirport
            ? selectedOutboundAirport.value
              ? e.OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
                  .DepartureAirportRef.AirportCode ===
                selectedOutboundAirport.value
              : true
            : true
        )
        .filter((e) =>
          selectedDeparture
            ? selectedDeparture.outboundairport
              ? e.OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
                  .DepartureAirportRef.AirportCode ===
                  selectedDeparture.outboundairport &&
                e.OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
                  .DepartureTime === selectedDeparture.time &&
                e.OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
                  .DepartureDate === selectedDeparture.date
              : true
            : true
        )
        .filter((e) =>
          selectedArrival
            ? selectedArrival.inboundairport
              ? e.OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
                  .DepartureAirportRef.AirportCode ===
                  selectedArrival.inboundairport &&
                e.OfferServices.Package.Flight?.InboundFlight.FlightDeparture
                  .DepartureTime === selectedArrival.time &&
                e.OfferServices.Package.Flight?.InboundFlight.FlightDeparture
                  .DepartureDate === selectedArrival.date
              : true
            : true
        )
        .filter((e) =>
          selectedArrival && selectedDeparture
            ? selectedArrival.outboundairport
              ? e.OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
                  .DepartureAirportRef.AirportCode ===
                  selectedArrival.inboundairport &&
                e.OfferServices.Package.Flight?.InboundFlight.FlightDeparture
                  .DepartureTime === selectedArrival.time &&
                e.OfferServices.Package.Flight?.InboundFlight.FlightDeparture
                  .DepartureDate === selectedArrival.date &&
                e.OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
                  .DepartureAirportRef.AirportCode ===
                  selectedDeparture.outboundairport &&
                e.OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
                  .DepartureTime === selectedDeparture.time &&
                e.OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
                  .DepartureDate === selectedDeparture.date
              : true
            : true
        )
        .filter((e) => offer.OfferID !== e.OfferID)
        /*.filter((e) =>
          display
            ? e.OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
                .DepartureAirportRef.AirportCode ===
                offer.OfferServices.Package.Flight?.OutboundFlight
                  .FlightDeparture.DepartureAirportRef.AirportCode &&
              offer.OfferID !== e.OfferID
            : e.OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
                .DepartureAirportRef.AirportCode !==
                offer.OfferServices.Package.Flight?.OutboundFlight
                  .FlightDeparture.DepartureAirportRef.AirportCode &&
              offer.OfferID !== e.OfferID
        )*/
        .sort((a, b) => {
          return selectedArrival
            ? selectedArrival.inboundairport
              ? a?.OfferServices?.Package?.Flight?.OutboundFlight
                  ?.FlightDeparture?.DepartureTime
                ? (
                    a.OfferServices.Package.Flight.OutboundFlight
                      .FlightDeparture.DepartureTime + ""
                  ).localeCompare(
                    b?.OfferServices?.Package?.Flight?.OutboundFlight
                      ?.FlightDeparture?.DepartureTime
                  )
                : 0
              : 0
            : 0;
        })
        .sort((a, b) => {
          return selectedDeparture
            ? selectedDeparture.outboundairport
              ? a?.OfferServices?.Package?.Flight?.InboundFlight
                  ?.FlightDeparture?.DepartureTime
                ? (
                    a.OfferServices.Package.Flight.InboundFlight.FlightDeparture
                      .DepartureTime + ""
                  ).localeCompare(
                    b?.OfferServices?.Package?.Flight?.InboundFlight
                      ?.FlightDeparture?.DepartureTime
                  )
                : 0
              : 0
            : 0;
        })
        .sort((a, b) => {
          return selectedOutboundAirport
            ? selectedOutboundAirport.value
              ? a?.OfferServices?.Package?.Flight?.OutboundFlight
                  ?.FlightDeparture?.DepartureTime
                ? (
                    a.OfferServices.Package.Flight.OutboundFlight
                      .FlightDeparture.DepartureTime + ""
                  ).localeCompare(
                    b?.OfferServices?.Package?.Flight?.OutboundFlight
                      ?.FlightDeparture?.DepartureTime
                  )
                : 0
              : 0
            : 0;
        })
        .map((co, i) => {
          ct = ct + 1;
          if (
            !(
              i >= 20 * (alternativeFlightPage - 1) &&
              i < 20 * alternativeFlightPage
            )
          )
            return <></>;

          let paddingLeft = false;
          offerDisplayed = true;
          if (
            lastOutbound.depdate ===
              co.OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
                .DepartureDate &&
            lastOutbound.deptime ===
              co.OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
                .DepartureTime &&
            lastOutbound.arrtime ===
              co.OfferServices.Package.Flight?.OutboundFlight.FlightArrival
                .ArrivalTime &&
            lastOutbound.arrdate ===
              co.OfferServices.Package.Flight?.OutboundFlight.FlightArrival
                .ArrivalDate &&
            lastOutbound.airport ===
              co.OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
                .DepartureAirportRef.AirportCode
          ) {
            paddingLeft = true;
          }
          lastOutbound = {
            depdate:
              co.OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
                .DepartureDate,
            deptime:
              co.OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
                .DepartureTime,
            arrdate:
              co.OfferServices.Package.Flight?.OutboundFlight.FlightArrival
                .ArrivalDate,
            arrtime:
              co.OfferServices.Package.Flight?.OutboundFlight.FlightArrival
                .ArrivalTime,
            airport:
              co.OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
                .DepartureAirportRef.AirportCode,
          };
          return (
            <div
              className={i % 2 === 0 ? "offerflightrow1" : "offerflightrow2"}
              style={{ padding: 8, display: "flex" }}
            >
              <OfferFlight offer={co} stations={stations} horizontal={true} />
              <Offerprice
                dispatch={dispatch}
                offsetTop={offsetTop}
                offer={offer}
                co={co}
                flexSelected={flexSelected}
                hotelOfferInfos={hotelOfferInfos}
                addOffer={addOffer}
              />
              <div
                style={{
                  display: "flex",
                  marginLeft: 10,
                  flexDirection: "column",
                }}
              >
                <div style={{ flexGrow: 1 }}></div>
                <AvailabilityButton
                  mainOffer={mainOffer}
                  flightOffer={flightOffer}
                  offer={co}
                  hotel={hotel}
                  inboundView={views.hotelcrossview}
                  parentid={offer.OfferID}
                  availableAction={(off) => {
                    window.scrollTo(0, offsetTop);

                    if (addOffer) {
                      if (Array.isArray(hotelOfferInfos?.Offers?.Offer)) {
                        let tmp = [...hotelOfferInfos.Offers.Offer];
                        let found = false;
                        for (let i = 0; i < tmp.length; i++) {
                          if (tmp[i].OfferID === co.OfferID) {
                            found = true;
                            break;
                          }
                        }

                        if (!found) {
                          tmp.push(co);
                          let offs = { ...hotelOfferInfos.Offers };
                          offs.OfferCount = offs.OfferCount + 1;
                          offs.Offer = [...tmp];
                          dispatch(
                            setHotelOfferInfos({
                              ...hotelOfferInfos,
                              Offers: offs,
                            })
                          );
                        }
                      }
                    }
                    dispatch(
                      setOfferFlexbooked({
                        offerId: co.OfferID,
                        flexbooked: flexSelected,
                      })
                    );
                    dispatch(setOfferId(co.OfferID));
                  }}
                  availableText={"übernehmen"}
                />
              </div>
            </div>
          );
        })}
      {ct > 20 && (
        <div>
          <span>{ct} Alternative Flüge</span>
          <br />
          <span>Seite: </span>

          {[...Array(Math.ceil(ct / 20))].map((e, i) => {
            return (
              <span>
                {i > 0 && <>&nbsp;|&nbsp;</>}
                <span
                  style={{
                    fontWeight:
                      i + 1 === alternativeFlightPage ? 700 : undefined,
                    cursor:
                      i + 1 !== alternativeFlightPage ? "pointer" : undefined,
                  }}
                  onClick={() => {
                    if (i + 1 !== alternativeFlightPage)
                      setAlternativeFlightPage(i + 1);
                  }}
                >
                  {i + 1}
                </span>
              </span>
            );
          })}
        </div>
      )}
      {!display &&
        !offerDisplayed &&
        offerCountBeforefilter > 0 &&
        (selectedArrival.inboundairport ||
          selectedDeparture.outboundairport) && (
          <span>
            Bitte wählen Sie einen anderen Hin- oder Rückflug aus. Ihre Auswahl
            steht nicht zur Verfügung.
          </span>
        )}
    </>
  );
}

const Offerprice = (props) => {
  const {
    dispatch,
    offsetTop,
    co,
    offer,
    addOffer,
    hotelOfferInfos,
    flexSelected,
  } = props;

  let offerrealprice = 0;

  if (offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._) {
    offerrealprice =
      offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._ * 1;
  } else {
    offerrealprice =
      offer.PriceInfo.Price.value * (offer.adults * 1 + offer.children * 1);
  }

  let corealprice = 0;

  if (co?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._) {
    corealprice = co?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._ * 1;
  } else {
    corealprice =
      co.PriceInfo.Price.value * (offer.adults * 1 + offer.children * 1);
  }

  if (
    Array.isArray(co?.MarketingActions) &&
    co.MarketingActions.length > 0 &&
    co.MarketingActions[0].flexconditions?.flexoptions?.flexoptionprice &&
    flexSelected
  ) {
    corealprice +=
      co.MarketingActions[0].flexconditions?.flexoptions?.flexoptionprice * 1;
  }

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div className="growbox"></div>
      <div>
        <div
          style={{ cursor: "text" }}
          className="offerflightprice"
          onClick={() => {
            /* window.scrollTo(0, offsetTop);
          if (addOffer) {
            if (Array.isArray(hotelOfferInfos?.Offers?.Offer)) {
              let tmp = [...hotelOfferInfos.Offers.Offer];
              let found = false;
              for (let i = 0; i < tmp.length; i++) {
                if (tmp[i].OfferID === co.OfferID) {
                  found = true;
                  break;
                }
              }

              if (!found) {
                tmp.push(co);
                let offs = { ...hotelOfferInfos.Offers };
                offs.OfferCount = offs.OfferCount + 1;
                offs.Offer = [...tmp];
                dispatch(
                  setHotelOfferInfos({ ...hotelOfferInfos, Offers: offs })
                );
              }
            }
          }
          dispatch(setOfferId(co.OfferID));
        }*/
          }}
        >
          <div>
            {corealprice > offerrealprice ? <>+&nbsp;</> : <>-&nbsp;</>}
            {nf.format(Math.abs(corealprice - offerrealprice).toFixed(0))}{" "}
            {currencySymbol(co.PriceInfo.Price.CurrencyCode)}
            &nbsp;(
            {nf.format(corealprice)}{" "}
            {currencySymbol(co.PriceInfo.Price.CurrencyCode)})
          </div>
        </div>
      </div>
    </div>
  );
};
